import { convertToFirstReference } from "../util/prints";

export class Print {


    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
        const printBtns = document.querySelectorAll('.sp-offers-list .sp-offers-item .sp-offers-cta .secondary-btn');
        if (printBtns)
            printBtns.forEach((printBtn: any, index) => {
                // Only attach if NOT inside the special section
                const parentSection = printBtn.closest('section.sp-offers-section.coupons-section.fte-special-offers-list');
                if (!parentSection &&  !(printBtn?.getAttribute('href') !== '' && printBtn?.getAttribute('href') !== '#')) {
                    printBtn.addEventListener('click', (e: any) => this.printOffer(e, index));
                }
            });
            // const printBtnsCoupon = document.querySelectorAll('.offers-block-section .offers-block-wrapper .offers-block-item .secondary-btn');
            // if (printBtnsCoupon)
            //     printBtnsCoupon.forEach((btn, index) => {
            //         btn.addEventListener('click', (e) => this.printCoupon.call(this, e, index));
            //     });
        });
    }

    private printOffer(e: Event, index: any) {
        //  e.preventDefault();
        // e.stopPropagation();
        const userAgent = navigator.userAgent;
        const isIOS = /iPad|iPhone|iPod/.test(userAgent);
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
        const isMacOS = /Macintosh/.test(userAgent); 
        const shouldUseAlternativePrint = isIOS || (isSafari && isMacOS);
        const formDiv = (document.querySelectorAll('.sp-offers-item')[index] || document.querySelectorAll('.offers-block-item')[index]) as HTMLDivElement;
        // Check if alternative print is needed
        if(shouldUseAlternativePrint){
            const printWindow = window.open('', '_blank');
            if(printWindow){
                printWindow.document.writeln(`
                    <html>
                <head>
                    <link rel="stylesheet" type="text/css" href="/brand/_assets/css/service.css" media="all">
                    <link rel="stylesheet" type="text/css" href="/brand/_assets/css/main.css" media="all">
                    <link rel="stylesheet" type="text/css" href="/brand/_assets/css/brand-config.css" media="all">
                    <link rel="stylesheet" type="text/css" href="/brand/_assets/css/header.css" media="all">
                    <link rel="stylesheet" type="text/css" href="/brand/_assets/css/footer.css" media="all">
                    <link rel="stylesheet" type="text/css" href="/brand/_assets/css/glossary.css" media="all">
                    <style>
                        @page { margin: 0mm; }
                        * {
                            -webkit-print-color-adjust: exact !important;
                            color-adjust: exact !important;
                        }
                        .claim-offer { display: none; }
                        @media print {
                            @-moz-document url-prefix() {
                                .btn-group li {
                                    display: none !important;
                                }
                                .btn-group li:first-child {
                                    display: block !important;
                                }
                            }
                        }
                    </style>
                </head>
                <body>
                    <section class="sp-offers-section">
                        <div class="container">
                            <ul class="sp-offers-list">
                                ${formDiv.classList.contains("offers-block-item") ? 
                                    this.convertToFirstReference(formDiv).innerHTML : 
                                    formDiv.innerHTML}
                            </ul>
                        </div>
                    </section>
                </body>
                </html>
                    `)
                printWindow.document.close();
                printWindow.focus();
                setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                }, 250);
            }else{
                alert('Printing is blocked by the browser. Please allow pop-ups for this site to print the offer.');
            }
            //  If alternative print was used return to prevent default print
            return; 
        }
            // Create an iframe element
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            const iframeDoc = iframe.contentWindow?.document;
        if (iframeDoc) {
            iframeDoc.open();
            iframeDoc.write('<html><head>');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/service.css" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/main.css" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/brand-config.css" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/header.css" media="all">')
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/footer.css" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/glossary.css" media="all">');
            iframeDoc.write(`<style>
            @page {
                margin:0mm;
                
              }
              * {
                -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
                color-adjust: exact !important;                 /*Firefox*/
            }
            .claim-offer{
                display:none
            }
            @media print { 
                @-moz-document url-prefix() {
            
                 .btn-group li {
                    display: none !important;
                 }
                 .btn-group li:first-child {
                    display: block !important;
                 }
                    }
                  .sp-offers-cta,.print-offer-link-wrap {
                     display: none !important;
                    }
                     .sp-offers-disclaimer,
                    .sp-offers-disclaimer * {
                        display: block !important;
                        visibility: visible !important;
                        height: auto !important;
                        overflow: visible !important;
                        opacity: 1 !important;
                        clip: auto !important;
                        position: static !important;
                    }
            
                    .sp-offers-disclaimer p {
                        display: block !important;
                        visibility: visible !important;
                        margin: 0 !important;
                        padding: 0 !important;
                    }
            
                    .sp-offers-disclaimer p a {
                        display: inline !important;
                        visibility: visible !important;
                        text-decoration: none !important;
                        color: inherit !important;
                    }
            }
            
            </style>
            `);
            iframeDoc.write('</head>');
            iframeDoc.write('<body>');
            iframeDoc.write('<section class="sp-offers-section">');
            iframeDoc.write('<div class="container">');
            iframeDoc.write('<ul class="sp-offers-list">');
            if (formDiv && formDiv.classList.contains("offers-block-item")) {
                const secondHtmlElement: HTMLElement = formDiv;
                const convertedElement = this.convertToFirstReference(secondHtmlElement);
                iframeDoc.write(convertedElement.innerHTML);
            } else {
                iframeDoc.write(formDiv.innerHTML);
            }
            iframeDoc.write('</div">');
            iframeDoc.write('</ul">');
            iframeDoc.write('</section>');
            iframeDoc.write('</body></html>');
            iframeDoc.close();
            
            // Wait for the iframe content to load before printing
            iframe.onload = function () {
                    try {
                        iframe.contentWindow?.focus();
                        iframe.contentWindow?.print();
                    } catch (error) {
                        console.log("err", error)
                    }
                };
    
                // Additional error handling for onload event
                iframe.onerror = function (errorEvent) {
                    console.log(errorEvent);
                };

        } else {
            alert('Printing is blocked by the browser. Please allow pop-ups for this site to print the offer.');
        }
    }
    private convertToFirstReference(htmlElement: HTMLElement): HTMLElement {
        return convertToFirstReference(htmlElement); // <--- using the exported version from util
    }


    private printCoupon(e: Event, index: any) {
        e.preventDefault();
        e.stopPropagation();

        var urlLink = window.location.href.split('/');
        var isWebSite = urlLink[3] === "ca" ? "ca" : "us";
        var brandCss = isWebSite == 'ca' ? "/us/en-us/brand/_assets/css/" + urlLink[4] + ".css" : "/us/en-us/brand/_assets/css/" + urlLink[3] + ".css";

        const formDiv = document.getElementById(`tns1-item${index}`) as HTMLDivElement;
        // Create an iframe element
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (iframeDoc) {
            iframeDoc.open();
            iframeDoc.write('<html><head>');
            iframeDoc.write('<link type="text/css" href="opus2.css" rel="stylesheet" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/service.css" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/main.css" media="all">');
            iframeDoc.write(`<link rel="preload" href="${brandCss}" as="style">`);
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/brand-config.css" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/header.css" media="all">')
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/footer.css" media="all">');
            iframeDoc.write('<link rel="stylesheet" type="text/css" href="/brand/_assets/css/glossary.css" media="all">');
            iframeDoc.write(`<link href="${brandCss}" rel="stylesheet" type="text/css" media="all" />`);
            iframeDoc.write(`<style>
            @media print{ 
                margin:0mm;
                body {
                    display: none; /* Hide the main page content */
                  }
                  
                  iframe {
                    display: block; /* Display the iframe content */
                  }
              }
              * {
                -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
                color-adjust: exact !important;                 /*Firefox*/
            }
            .claim-offer{
                display:none
            }
            @media print { 
                @-moz-document url-prefix() {
            
                 .btn-group li {
                    display: none !important;
                 }
                 .btn-group li:first-child {
                    display: block !important;
                 }
                    }
            }
            
            </style>`);
            iframeDoc.write('</head>');
            iframeDoc.write('<body>');
            iframeDoc.write('<section class="offers-block-section">');
            iframeDoc.write('<div class="container">');
            iframeDoc.write('<div class="offers-block-wrapper">');
            iframeDoc.write('<ul class="offers-block-list offers-slider">');
            iframeDoc.write(formDiv.innerHTML);
            iframeDoc.write('</div">');
            iframeDoc.write('</div">');
            iframeDoc.write('</ul">');
            iframeDoc.write('</section>');
            iframeDoc.write('</body></html>');
            iframeDoc.close();
            // Wait for the iframe content to load before printing
            try {
                setTimeout(function () {
                    iframeDoc.close();
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                }, 250);

            } catch (error) {

                

            }
        } else {
            alert('Printing is blocked by the browser. Please allow pop-ups for this site to print the offer.');
        }
    }
}

new Print();